import { Card as MuiCard, CardContent, withStyles } from '@material-ui/core';
import { AirportShuttle } from '@material-ui/icons';
import * as React from 'react';
import { GridShowLayout, RaGrid } from 'ra-compact-ui';
import {
  Datagrid,
  FilterList,
  FilterListItem,
  FilterLiveSearch,
  List,
  ReferenceField,
  Show,
  TextField,
  useGetPermissions,
  usePermissions,
} from 'react-admin';
import { getBommedExporter } from '../util/sheet';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';
import { FdAddressField } from '../common/components/FdAddressField';

const exporter = getBommedExporter('supplier', {headers: ['id', 'name', 'ceoName', 'ceoTelNo', 'address', 'serviceFee', 'bank', 'accountNo', 'accountHolder', 'invoiceBusinessNo', 'invoiceBusinessType', 'invoiceCustomerName', 'invoiceCeoName', 'invoiceEmail', 'memo']});
const Card = withStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      order: -1, // display on the left rather than on the right of the list
      width: '15em',
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))(MuiCard);

const ServiceFilter = () => (
  <FilterList label='서비스 여부' icon={<AirportShuttle />}>
    <FilterListItem
      label='서비스 중'
      value={{
        curation: true,
      }}
    />
    <FilterListItem
      label='해지'
      value={{
        curation: false,
      }}
    />
  </FilterList>
);
const FilterSidebar = () => (
  <Card>
    <CardContent>
      <FilterLiveSearch source='name' />
      <ServiceFilter />
    </CardContent>
  </Card>
);

export const SupplierList = (props) => {

  const hasEditPermission = useHasPermissions(Resources.Supplier, Actions.Edit);

  return (
    <List
      {...props}
      perPage={25}
      aside={<FilterSidebar />}
      filterDefaultValues={{ curation: true }}
      sort={{ field: 'address', order: 'ASC' }}
      exporter={exporter}
    >
      <Datagrid 
        rowClick={hasEditPermission ? 'edit' : 'show'}
      >
        <TextField source='id' label='id' />
        <TextField source='name' label='상호명' />
        <TextField source='ceoName' label='대표자명' />
        <TextField source='ceoTelNo' label='연락처' />
        {/* <TextField source='address' label='위치' /> */}
        <FdAddressField label="주소정보" />
        <TextField source='menuCount' label='메뉴수' sortable={false} />
        <TextField source='ratingUser' label='전체평점' sortable={false} />
      </Datagrid>
    </List>
  );
}